export type IListnerFc = (...args: any) => void;

export type IEventorListners = Record<string, IListnerFc[]>;

export enum NodeEvents {
	OutputsChangeViewer = "outputs-change-viewer",
	MyModalsWasFetched = "myModalsWasFetched",
	PreExecutePreparing = "preExecutePreparing",
	OutputsChange = "outputs-change",
	InputsChange = "inputs-change",
	ParamsChange = "params-change",
	Ready = "ready",
	Remove = "remove",
	ComposeChange = "composeChange",
	NodeSelected = "NodeSelected",
	SuccessfullExecute = "SuccessfullExecute",
	PreSavePreparing = "preSavePreparing"
}

export enum SocketEvents {
	Change = "change",
	ConnectionChange = "connection-change",
	AddConnection = "new-connection",
	RemoveConnection = "remove-connection",
	OpenSelect = "open-select"
}
